<div *ngIf="data && data.isOffersValidation" class="row justify-content-center">
  <div class="col-sm-12">
    <div class="row justify-content-center marginBottom_40 marginTop_20">
      <img class="warning-logo" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
      <span class="labelTitle_xlarge">{{'csa.warning' | translate}}</span>
      <span class="labelTitle_unset marginTop_20">{{'csa.warning.text' | translate}}</span>
    </div>
  </div>
  <div class="col-sm-12 buttons d-flex justify-content-center pad" style="padding-top: 20px">
    <button class="primary-orange-button pt-2 pb-2" (click)="onTCClick()">{{'csa.close' | translate}}</button>
  </div>
</div>
